import React from 'react';
import styles from './RoleManagement.module.css';

const RoleManagementHeader = ({ onCreateClick }) => {
    return (
        <div className={styles.header}>
            <h1 className={styles.title}>Role Management</h1>
            <button className={styles.createButton} onClick={onCreateClick}>
                <span className={styles.buttonIcon}>+</span>
                Create Role
            </button>
        </div>
    );
};

export default RoleManagementHeader;